import { useTheme } from './contexts/ThemeContext';
import { App as Antd, ConfigProvider } from 'antd';
import { ConfigProvider as MobileAntDesignConfigProvider } from 'antd-mobile';
import enUS from 'antd-mobile/es/locales/en-US';
import enUSAntd from 'antd/locale/en_US';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { GlobalStyles } from './GlobalStyles';

export const ApplicationThemeWrapper = ({ children }: { children: React.ReactNode }) => {
  const { themeAlgorithm, customTheme, combinedTheme } = useTheme();

  return (
    <Antd>
      <ConfigProvider theme={{ algorithm: themeAlgorithm, ...customTheme }} locale={enUSAntd}>
        <StyledThemeProvider theme={combinedTheme}>
          <MobileAntDesignConfigProvider locale={enUS}>
            <GlobalStyles theme={combinedTheme} />
            {children}
          </MobileAntDesignConfigProvider>
        </StyledThemeProvider>
      </ConfigProvider>
    </Antd>
  );
};
